<h2 mat-dialog-title>Editar Datos del Documento</h2>

<mat-dialog-content>
    <div class="dialog-subtitle">
        <mat-icon>description</mat-icon>
        <span>{{ invoiceTitle }}</span>
    </div>

    <form [formGroup]="editForm" class="edit-form">
        @if (!isReferral) {
        <div class="form-section">
            <h4>Datos Fiscales</h4>
            <div class="row">
                <mat-form-field appearance="outline" class="full">
                    <mat-label>CFDI (UUID)</mat-label>
                    <input matInput formControlName="uuid">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field appearance="outline" class="half">
                    <mat-label>Serie</mat-label>
                    <input matInput formControlName="serie">
                </mat-form-field>
                <mat-form-field appearance="outline" class="half">
                    <mat-label>Folio</mat-label>
                    <input matInput formControlName="folio">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field appearance="outline" class="half">
                    <mat-label>Nombre Emisor</mat-label>
                    <input matInput formControlName="emisorNombre">
                </mat-form-field>
                <mat-form-field appearance="outline" class="half">
                    <mat-label>RFC Emisor</mat-label>
                    <input matInput formControlName="emisorRFC" style="text-transform: uppercase;">
                    <mat-error>RFC inválido</mat-error>
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field appearance="outline" class="half">
                    <mat-label>Nombre Receptor</mat-label>
                    <input matInput formControlName="receptorNombre">
                </mat-form-field>
                <mat-form-field appearance="outline" class="half">
                    <mat-label>RFC Receptor</mat-label>
                    <input matInput formControlName="receptorRFC" style="text-transform: uppercase;">
                    <mat-error>RFC inválido</mat-error>
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field appearance="outline" class="third">
                    <mat-label>Fecha Emisión</mat-label>
                    <input matInput type="date" formControlName="fechaEmision">
                </mat-form-field>
                <mat-form-field appearance="outline" class="third">
                    <mat-label>Total</mat-label>
                    <input matInput type="number" formControlName="total">
                </mat-form-field>
                <mat-form-field appearance="outline" class="third">
                    <mat-label>Moneda</mat-label>
                    <input matInput formControlName="moneda" placeholder="MXN">
                </mat-form-field>
            </div>
        </div>
        } @else {
        <div class="form-section">
            <h4>Datos de Remisión</h4>
            <div class="row">
                <mat-form-field appearance="outline" class="half">
                    <mat-label>Folio Remisión</mat-label>
                    <input matInput formControlName="folioRemision">
                </mat-form-field>
                <mat-form-field appearance="outline" class="half">
                    <mat-label>Folio Orden</mat-label>
                    <input matInput formControlName="folioOrden">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field appearance="outline" class="half">
                    <mat-label>Fecha Remisión</mat-label>
                    <input matInput type="date" formControlName="fechaEmision">
                </mat-form-field>
                <mat-form-field appearance="outline" class="half">
                    <mat-label>Total</mat-label>
                    <input matInput type="number" formControlName="total">
                </mat-form-field>
            </div>
        </div>
        <div class="form-section">
            <h4>Datos de Proveedor</h4>
            <div class="row">
                <mat-form-field appearance="outline" class="half">
                    <mat-label>Nombre Proveedor</mat-label>
                    <input matInput formControlName="proveedorNombre">
                </mat-form-field>
                <mat-form-field appearance="outline" class="half">
                    <mat-label>RFC Proveedor</mat-label>
                    <input matInput formControlName="proveedorRFC" style="text-transform: uppercase;">
                    <mat-error>RFC inválido</mat-error>
                </mat-form-field>
            </div>
        </div>
        }
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancelar</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="editForm.invalid">
        <mat-icon>save</mat-icon>
        Guardar Cambios
    </button>
</mat-dialog-actions>
